<template>
  <div>
    <!-- <div v-if="loading" class="title-section-content">
      <h3>Carregando...</h3>
    </div>-->
    <div style="padding-left:0px;padding-right:0px;" class="modules-content">
      <div class="module-item">
        <div class="title-content" style="grid-gap:0;">
          <h3 class="module-title">Módulos do produto</h3>
          <a v-if="addNew==false" v-on:click="addNew=true" class="form-control btn btn-default-lms">
            Adicionar
            <i class="fa fa-plus"></i>
          </a>
          <a
            v-else
            v-on:click="selectedCourseId = null;selectedModule = {};addNew=false;"
            class="form-control btn btn-default-lms"
          >
            Cancelar
            <i class="fa fa-times-circle"></i>
          </a>
          <div>
            <span class="module-progress loading-placeholder"></span>
          </div>
        </div>

        <li class="lesson-subtitle li-custom">
          <span class="lesson-title">Curso</span>
          <span class="lesson-description">Módulo</span>
          <span class="lesson-option"></span>
        </li>

        <ul class="lessons-list">
          <li v-if="addNew" class="lesson li-custom-add">
            <select class="lesson-title" @change="getModules($event)" v-model="selectedCourseId">
              <option disabled value>Escolha um curso</option>
              <option
                v-for="course in courses"
                v-bind:key="course.id"
                v-bind:value="course.id"
              >{{course.name}}</option>
            </select>

            <select
              :class="{ 'has-error': $v.selectedModule.$error }"
              class="lesson-description"
              v-model="selectedModule"
            >
              <option disabled value>Escolha um módulo</option>
              <option
                v-for="module in modules"
                v-bind:key="module.id"
                v-bind:value="module"
              >{{module.name}}</option>
            </select>

            <span class="lesson-option">
              <a
                :disabled="loading"
                :class="{ 'disabled': $v.selectedModule.$error }"
                v-on:click="addModule()"
                href="#"
              >Adicionar Módulo</a>
            </span>

            <span class="lesson-option">
              <a
                :disabled="loading"
                :class="{ 'disabled': $v.selectedModule.$error }"
                v-on:click="addCourse()"
                href="#"
              >Adicionar Curso</a>
            </span>
          </li>

          <li
            v-show="!loading"
            v-for="module in productModules"
            :key="module.id"
            class="lesson li-custom"
          >
            <span class="lesson-title">{{module.courseName}}</span>
            <span class="lesson-title">{{module.name}}</span>
            <span class="lesson-option">
              <a v-on:click="removeLesson(module.id)" href="#">Remover</a>
            </span>
          </li>

          <li v-show="loading" style="margin-left:auto;margin-right:auto;">
            <loading :color="'#1abdde'" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped>
.li-custom-add {
  grid-template-columns: 1.5fr 1fr 0.75fr 0.75fr !important;
}

.li-custom {
  grid-template-columns: 1.5fr 1fr 0.75fr !important;
}

a.disabled {
  pointer-events: none;
  cursor: default;
}
.has-error {
  border-color: #a94442;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
</style>


<script>
import axios from "axios";
import { required, minLength } from "vuelidate/lib/validators";

axios.defaults.withCredentials = true;

export default {
  props: ["product", "courses", "productModules"],
  data() {
    return {
      loading: false,
      addNew: false,
      modules: [],
      selectedCourseId: null,
      selectedModule: {}
    };
  },
  validations: {
    selectedModule: { id: { required } },
    selectedCourseId: { required }
  },
  computed: {
    getTeacherName() {
      if (this.selectedModule.teacher) return this.selectedModule.teacher.name;
      else return "";
    }
  },
  components: {},
  methods: {
    addCourse() {
      for (let i = 0; i < this.modules.length; i++) {
        this.loading = true;

        const path = this.$global.endpoint + "/product/admin/module/save";
        axios
          .post(path, {
            productId: this.product.id,
            moduleId: this.modules[i].id
          })
          .then(res => {
            this.getProductModules();
            this.selectedCourseId = null;
            this.selectedModule = {};
            this.loading = false;
          })
          .catch(error => {
            console.error(error);
            this.loading = false;
          });
      }
    },

    addModule() {
      this.loading = true;
      this.$v.selectedModule.$touch();
      if (this.$v.selectedModule.$error) {
        console.log("erro");
        return;
      }

      const path = this.$global.endpoint + "/product/admin/module/save";
      axios
        .post(path, {
          productId: this.product.id,
          moduleId: this.selectedModule.id
        })
        .then(res => {
          this.getProductModules();
          this.selectedCourseId = null;
          this.selectedModule = {};
        })
        .catch(error => {
          console.error(error);
        });
    },
    getModules(event) {
      this.loading = true;
      const path = this.$global.endpoint + "/module/getall";
      axios
        .post(path, { courseId: event.target.value })
        .then(res => {
          this.modules = res.data;
          this.loading = false;
        })
        .catch(error => {
          console.error(error);
          this.loading = false;
        });
    },
    getProductModules() {
      const path = this.$global.endpoint + "/product/admin/module/getall";
      axios
        .post(path, { productId: this.product.id })
        .then(res => {
          this.productModules = res.data;
          this.loading = false;
        })
        .catch(error => {
          console.error(error);
          this.loading = false;
        });
    },
    removeLesson(moduleId) {
      this.loading = true;
      const path = this.$global.endpoint + "/product/admin/module/remove";
      axios
        .post(path, {
          productId: this.product.id,
          moduleId: moduleId
        })
        .then(res => {
          this.getProductModules();
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  created() {}
};
</script>
